<p-toast></p-toast>
<p-confirmDialog [acceptLabel]="'common.sim' | translate" [rejectLabel]="'common.nao' | translate"></p-confirmDialog>

<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-user-edit"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'contador_operar.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'contador_operar.descricao' | translate }}</p>
  </div>

  <!-- Seletor de cliente no topo, a direita, na linha do titulo -->
  <div class="header-cliente">
    <div *ngIf="carregandoClientes" class="estado-inline">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'contador_operar.seletor.carregando' | translate }}</span>
    </div>

    <div *ngIf="!carregandoClientes && erroClientes" class="estado-inline estado-erro">
      <span>{{ 'contador_operar.seletor.erro_carregar' | translate }}</span>
      <button pButton icon="pi pi-refresh" class="p-button-text btn-sm" (click)="recarregarClientes()"></button>
    </div>

    <span *ngIf="!carregandoClientes && !erroClientes && clientes.length === 0" class="header-cliente-vazio">
      {{ 'contador_operar.seletor.nenhum_cliente' | translate }}
    </span>

    <!-- Seletor de cliente no MESMO padrao da tela de Vendas (app-entity-selector):
         autocomplete com lupa, avatar, id e nome/e-mail em duas linhas. Aqui a
         busca e em memoria: a lista de clientes do contador ja vem inteira do
         backend (size=200), entao nao ha ida ao servidor a cada tecla. -->
    <div *ngIf="!carregandoClientes && !erroClientes && clientes.length > 0"
      class="entity-ac-wrapper header-cliente-selector">
      <p-autoComplete #clienteAc
        [(ngModel)]="clienteAutoComplete"
        [suggestions]="clientesFiltrados"
        (completeMethod)="filtrarClientes($event)"
        (onSelect)="onSelecionarCliente($event.value ?? $event)"
        (onClear)="trocarCliente()"
        field="nome"
        [minLength]="0"
        [delay]="0"
        [completeOnFocus]="true"
        [forceSelection]="false"
        [showEmptyMessage]="true"
        [emptyMessage]="'contador_operar.seletor.nenhum_encontrado' | translate"
        [placeholder]="'contador_operar.seletor.placeholder' | translate"
        styleClass="w-full"
        inputStyleClass="w-full entity-ac-input-icons"
        scrollHeight="400px"
        appendTo="body">

        <ng-template let-cliente pTemplate="item">
          <div class="entity-ac-item">
            <div class="entity-ac-avatar">
              <i class="pi pi-user"></i>
            </div>
            <div class="entity-ac-id">{{ cliente.empresaIndicadaId }}</div>
            <div class="entity-ac-info">
              <span class="entity-ac-nome">{{ cliente.nome }}</span>
              <span *ngIf="cliente.email" class="entity-ac-fantasia">{{ cliente.email }}</span>
            </div>
          </div>
        </ng-template>
      </p-autoComplete>

      <!-- Icones dentro do input: limpar + lupa (abre a lista completa) -->
      <div class="entity-ac-icons">
        <i *ngIf="clienteAutoComplete"
          class="pi pi-times entity-ac-icon-clear"
          [attr.aria-label]="'contador_operar.seletor.limpar' | translate"
          (click)="trocarCliente()"></i>
        <i class="pi pi-search entity-ac-icon-search"
          [attr.aria-label]="'contador_operar.seletor.placeholder' | translate"
          (click)="abrirListaClientes()"></i>
      </div>
    </div>
  </div>
</div>

<div class="page-body">

  <!-- Sem cliente selecionado: orientacao para usar o seletor do topo -->
  <div *ngIf="!clienteSelecionado && !carregandoClientes && !erroClientes && clientes.length > 0" class="form-card estado-vazio-card">
    <div class="card-content">
      <div class="estado-vazio estado-vazio-cliente">
        <div class="estado-vazio-icone">
          <i class="pi pi-arrow-up"></i>
        </div>
        <p class="estado-vazio-titulo">{{ 'contador_operar.seletor.placeholder' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- =================================================================== -->
  <!-- Blocos abaixo so aparecem com cliente selecionado                  -->
  <!-- =================================================================== -->
  <ng-container *ngIf="clienteSelecionado">
    <p-tabView styleClass="operar-tabs" [(activeIndex)]="abaAtivaIndex">

    <!-- ================= Aba 1: Contrato ================= -->
    <p-tabPanel [header]="'contador_operar.abas.contrato' | translate">
      <app-operar-despesa-acessoria [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
        modo="contrato">
      </app-operar-despesa-acessoria>
    </p-tabPanel>

    <!-- ================= Aba 2: Gastos acessorios ================= -->
    <p-tabPanel [header]="'contador_operar.abas.gastos_acessorios' | translate">
      <app-operar-despesa-acessoria [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
        modo="gastos">
      </app-operar-despesa-acessoria>
    </p-tabPanel>

    <!-- ================= Aba 3: Configuração da empresa ================= -->
    <p-tabPanel [header]="'contador_operar.abas.configuracao' | translate">
      <app-operar-config-empresa [clienteId]="clienteSelecionado.empresaIndicadaId">
      </app-operar-config-empresa>
    </p-tabPanel>

    <!-- ================= Aba 4: Extrato + Notas (com sub-abas) ================= -->
    <p-tabPanel [header]="'contador_operar.abas.extrato_notas' | translate">

    <p-tabView styleClass="operar-subtabs" [(activeIndex)]="subAbaExtratoIndex">

    <!-- Sub-aba 1: Nova venda (nota com fatura legal). Fica à esquerda para casar
         com o padrão das demais abas (registro/cadastro primeiro, listagem
         depois). A listagem continua sendo a exibida por padrão (índice 1). -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ 'contador_operar.abas.nova_venda' | translate }}</span>
      </ng-template>
      <!-- Cria uma nota com fatura legal de venda para o cliente, sob contexto
           (X-Empresa-Contexto). Carrega ao abrir a aba Extrato + esta sub-aba. -->
      <app-operar-venda
        [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
        [ativo]="abaAtivaIndex === 3 && subAbaExtratoIndex === 0"
        (vendaConcluida)="onVendaConcluida()"
        (notaTransmitida)="onNotaTransmitida()">
      </app-operar-venda>
    </p-tabPanel>

    <!-- Sub-aba 2: Listagem de notas (exibida por padrão) -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ 'contador_operar.abas.listagem_notas' | translate }}</span>
      </ng-template>

    <!-- ----------------------------------------------------------------- -->
    <!-- Card: Notas do Cliente (venda com fatura legal, filtrável por período) -->
    <!-- ----------------------------------------------------------------- -->
    <div class="form-card table-card">
      <div class="card-header">
        <div class="card-header-icon table-icon">
          <i class="pi pi-list"></i>
        </div>
        <span class="card-header-title">{{ 'contador_operar.notas.titulo' | translate }}</span>

        <!-- Filtros compactos (período + situação) + botões, à direita do
             cabeçalho (mesmo padrão da tela de Gastos accesorios). -->
        <div class="notas-header-acoes">
          <app-periodo-filtro
            class="filtro-compacto filtro-periodo"
            modo="avancado"
            [persistir]="false"
            [valorPadrao]="'thisMonth'"
            styleClass="w-full"
            [pTooltip]="'contador_operar.notas.periodo_label' | translate"
            tooltipPosition="top"
            (periodoChanged)="onPeriodoChanged($event)">
          </app-periodo-filtro>
          <p-dropdown
            class="filtro-compacto"
            [options]="estadoOptions"
            [(ngModel)]="estadoSelecionado"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'contador_operar.filtro_estado.todos' | translate"
            [pTooltip]="'contador_operar.filtro_estado.label' | translate"
            tooltipPosition="top"
            (onChange)="onEstadoChanged()">
          </p-dropdown>
          <!-- Adicionar nota: leva para a sub-aba "Nueva venta" -->
          <button pButton
            type="button"
            class="btn-primary btn-sm"
            icon="pi pi-plus"
            [label]="'contador_operar.notas.adicionar' | translate"
            (click)="subAbaExtratoIndex = 0">
          </button>
          <button pButton
            type="button"
            class="p-button-secondary btn-sm"
            [icon]="gerandoLivro ? 'pi pi-spin pi-spinner' : 'pi pi-file-export'"
            [label]="'contador_operar.livro.exportar' | translate"
            [disabled]="gerandoLivro"
            (click)="menuExportar.toggle($event)">
          </button>
          <p-menu #menuExportar [popup]="true" [model]="exportarLivroItens" appendTo="body"></p-menu>
        </div>
      </div>

      <div class="card-content">

        <p-table
          [value]="notas"
          [lazy]="true"
          (onLazyLoad)="onLazyLoadNotas($event)"
          [rows]="rows"
          [first]="first"
          [loading]="carregandoNotas"
          dataKey="id"
          styleClass="p-datatable-sm">

          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="codigoNota">
                {{ 'contador_operar.notas.col_codigo' | translate }}<p-sortIcon [field]="'codigoNota'"></p-sortIcon>
              </th>
              <th pSortableColumn="numeroFatura">
                {{ 'contador_operar.notas.col_identificacao' | translate }}<p-sortIcon [field]="'numeroFatura'"></p-sortIcon>
              </th>
              <th pSortableColumn="emissao">
                {{ 'contador_operar.notas.col_emissao' | translate }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
              </th>
              <th pSortableColumn="valorTotal">
                {{ 'contador_operar.notas.col_valor' | translate }}<p-sortIcon [field]="'valorTotal'"></p-sortIcon>
              </th>
              <th pSortableColumn="estadoNotaEletronica">
                {{ 'contador_operar.notas.col_situacao' | translate }}<p-sortIcon [field]="'estadoNotaEletronica'"></p-sortIcon>
              </th>
              <th class="col-acoes">{{ 'contador_operar.notas.col_acoes' | translate }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-nota>
            <tr>
              <td>{{ nota.codigoNota }}</td>
              <td>
                <div class="nota-id">
                  <span *ngIf="ehNotaEletronica(nota)" class="nota-tipo">
                    {{ 'contador_operar.notas.tipo_eletronica' | translate }}
                  </span>
                  <span *ngIf="numeroFaturaFormatado(nota)" class="nota-numero">
                    {{ numeroFaturaFormatado(nota) }}
                  </span>
                  <span *ngIf="nota.numeroFatura" class="nota-fatura">
                    {{ 'contador_operar.notas.fatura_prefixo' | translate }} {{ nota.numeroFatura }}
                  </span>
                  <span *ngIf="!nota.numeroFatura" class="nota-tipo">-</span>
                </div>
              </td>
              <td>{{ nota.emissao | date: 'dd/MM/yyyy' }}</td>
              <td>{{ valorNota(nota) | moedaSimbolo: cfgMoeda(nota).symbol : cfgMoeda(nota).digits : cfgMoeda(nota).locale }}</td>
              <td>
                <p-tag
                  [value]="estadoNfeLabel(nota)"
                  [severity]="estadoNfeSeverity(nota)">
                </p-tag>
              </td>
              <td class="col-acoes">
                <div class="acoes-nota">
                  <button pButton
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-text"
                    [pTooltip]="'contador_operar.notas.botao_visualizar' | translate"
                    tooltipPosition="top"
                    [attr.aria-label]="'contador_operar.notas.botao_visualizar' | translate"
                    (click)="visualizarNota(nota)">
                  </button>
                  <button pButton
                    type="button"
                    icon="pi pi-send"
                    class="p-button-rounded p-button-text"
                    *ngIf="ehNotaEletronica(nota)"
                    [pTooltip]="'contador_operar.notas.botao_emitir' | translate"
                    tooltipPosition="top"
                    [attr.aria-label]="'contador_operar.notas.botao_emitir' | translate"
                    [loading]="emitindoNotaId === nota.id"
                    [disabled]="emitindoNotaId !== null"
                    (click)="confirmarEmissao(nota)">
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">
                <div *ngIf="!erroNotas" class="estado-vazio">
                  <i class="pi pi-inbox"></i>
                  <p>{{ 'contador_operar.notas.vazio' | translate }}</p>
                </div>
                <div *ngIf="erroNotas" class="estado-vazio">
                  <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
                  <p>{{ 'contador_operar.notas.erro_carregar' | translate }}</p>
                  <button pButton
                    [label]="'contador.dashboard.estados.tentar_novamente' | translate"
                    icon="pi pi-refresh"
                    class="btn-primary btn-sm"
                    (click)="recarregarNotas()">
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Paginacao (mesmo modelo da Lista de Vendas): contagem a esquerda,
             rotulo "Itens por pagina" + dropdown a direita. Lazy load: a troca
             de pagina dispara onPageChangeNotas, que recarrega do backend. -->
        <div class="pagination-container">
          <div>
            <p-paginator
              (onPageChange)="onPageChangeNotas($any($event))"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'contador_operar.notas.contagem' | translate"
              [first]="first" [rows]="rows"
              [totalRecords]="totalRecords" [showFirstLastIcon]="true">
            </p-paginator>
          </div>
          <div class="flex align-items-center">
            <span class="mx-1 text-color">{{ 'contador_operar.notas.itens_por_pagina' | translate }}</span>
            <!-- appendTo="body": o painel seria recortado pelo overflow:hidden do
                 card; renderizado no body fica imune (igual aos demais dropdowns). -->
            <p-dropdown [options]="pageSizeOptions" optionLabel="label"
              optionValue="value" [(ngModel)]="rows"
              (ngModelChange)="onRowsPerPageChangeNotas()" styleClass="w-6rem"
              appendTo="body">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>

    </p-tabPanel>

    </p-tabView>

    </p-tabPanel>

    <!-- ================= Aba 5: Gestão de timbrado (logo após Extrato + Notas) ================= -->
    <p-tabPanel [header]="'contador_operar.abas.timbrado' | translate">
      <!-- Reusa a tela de timbrado sob contexto (X-Empresa-Contexto via interceptor).
           ocultarExcluir: nesta área o escopo é só listar/adicionar/editar. -->
      <app-timbrado [ocultarExcluir]="true" [ocultarCabecalho]="true"></app-timbrado>
    </p-tabPanel>

    <!-- ================= Aba 6: Artículos (com sub-abas) ================= -->
    <p-tabPanel [header]="'contador_operar.abas.itens' | translate">

    <p-tabView styleClass="operar-subtabs" [(activeIndex)]="subAbaArticulosIndex">

      <!-- Sub-aba 1: Artículos (itens) -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-box tab-icon"></i>
          <span>{{ 'contador_operar.abas.itens' | translate }}</span>
        </ng-template>
        <app-operar-itens
          [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
          [ativo]="abaAtivaIndex === 5 && subAbaArticulosIndex === 0">
        </app-operar-itens>
      </p-tabPanel>

      <!-- Sub-aba 2: Categorías (grupo) -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-th-large tab-icon"></i>
          <span>{{ 'contador_operar.abas.categorias' | translate }}</span>
        </ng-template>
        <app-operar-categorias
          [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
          [ativo]="abaAtivaIndex === 5 && subAbaArticulosIndex === 1">
        </app-operar-categorias>
      </p-tabPanel>

      <!-- Sub-aba 3: Subcategorías (subgrupo) -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-sitemap tab-icon"></i>
          <span>{{ 'contador_operar.abas.subcategorias' | translate }}</span>
        </ng-template>
        <app-operar-subcategorias
          [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
          [ativo]="abaAtivaIndex === 5 && subAbaArticulosIndex === 2">
        </app-operar-subcategorias>
      </p-tabPanel>

      <!-- Sub-aba 4: Marcas -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-tag tab-icon"></i>
          <span>{{ 'contador_operar.abas.marcas' | translate }}</span>
        </ng-template>
        <app-operar-marcas
          [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
          [ativo]="abaAtivaIndex === 5 && subAbaArticulosIndex === 3">
        </app-operar-marcas>
      </p-tabPanel>

      <!-- Sub-aba 5: Unidades -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-inbox tab-icon"></i>
          <span>{{ 'contador_operar.abas.unidades' | translate }}</span>
        </ng-template>
        <app-operar-unidades
          [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
          [ativo]="abaAtivaIndex === 5 && subAbaArticulosIndex === 4">
        </app-operar-unidades>
      </p-tabPanel>

    </p-tabView>
    </p-tabPanel>

    <!-- ================= Aba 7: Gestão de clientes ================= -->
    <p-tabPanel [header]="'contador_operar.abas.clientes' | translate">
      <!-- Reusa a tela de Clientes (embutida) sob contexto (X-Empresa-Contexto). -->
      <app-operar-clientes
        [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
        [ativo]="abaAtivaIndex === 6">
      </app-operar-clientes>
    </p-tabPanel>

    <!-- ================= Aba 8: Gestão de fornecedores ================= -->
    <p-tabPanel [header]="'contador_operar.abas.fornecedores' | translate">
      <!-- Reusa a tela de Fornecedores (embutida) sob contexto (X-Empresa-Contexto). -->
      <app-operar-fornecedores
        [clienteEmpresaId]="clienteSelecionado.empresaIndicadaId"
        [ativo]="abaAtivaIndex === 7">
      </app-operar-fornecedores>
    </p-tabPanel>

    </p-tabView>
  </ng-container>
</div>

<!-- =================================================================== -->
<!-- Popup "Estado factura electrónica" (card de NFe) — emitir/transmitir -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="mostrarDialogEstadoNfe"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '640px', maxWidth: '95vw' }"
  [breakpoints]="{ '640px': '95vw' }">

  <ng-container *ngIf="notaEstadoNfe">
    <!-- Header wave (--info) com badge de status preservado -->
    <div class="dialog-wave-header dialog-wave-header--info">
      <div class="dialog-wave-header-content">
        <div class="dialog-wave-icon-container">
          <i class="pi pi-file-edit" aria-hidden="true"></i>
        </div>
        <div class="dialog-wave-header-text">
          <h2>{{ 'fatura.labels.estado_fatura_eletronica' | translate }}</h2>
          <p class="dialog-wave-subtitle">{{ tipoNotaLabel(notaEstadoNfe) }}</p>
        </div>
        <div class="card-nfe-badge" [ngClass]="{
              'badge-pending': estadoNfeValue(notaEstadoNfe) === 'EM_DEFINICAO',
              'badge-success': estadoNfeValue(notaEstadoNfe) === 'AUTORIZADA' || estadoNfeValue(notaEstadoNfe) === 'APROVADO',
              'badge-danger': estadoNfeValue(notaEstadoNfe) === 'CANCELADA' || estadoNfeValue(notaEstadoNfe) === 'INUTILIZADA',
              'badge-warning': estadoNfeValue(notaEstadoNfe) === 'COM_PROBLEMAS'}">
          <i class="pi" [ngClass]="{
              'pi-clock': estadoNfeValue(notaEstadoNfe) === 'EM_DEFINICAO',
              'pi-check-circle': estadoNfeValue(notaEstadoNfe) === 'AUTORIZADA' || estadoNfeValue(notaEstadoNfe) === 'APROVADO',
              'pi-times-circle': estadoNfeValue(notaEstadoNfe) === 'CANCELADA' || estadoNfeValue(notaEstadoNfe) === 'INUTILIZADA',
              'pi-exclamation-triangle': estadoNfeValue(notaEstadoNfe) === 'COM_PROBLEMAS'}"></i>
          {{ estadoNfeLabel(notaEstadoNfe) }}
        </div>
      </div>
      <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
      <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
      <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
      </svg>
    </div>

    <!-- Corpo -->
    <div class="dialog-wave-body">
      <div class="card-nfe-info-grid">
        <div class="card-nfe-info-item">
          <div class="info-label">
            <i class="pi pi-hashtag text-blue-500"></i>
            {{ 'fatura.labels.protocolo' | translate }}
          </div>
          <div class="info-value font-mono">{{ notaEstadoNfe.protocoloNotaEletronica || '----------' }}</div>
        </div>
        <div class="card-nfe-info-item">
          <div class="info-label">
            <i class="pi pi-calendar text-blue-500"></i>
            {{ 'fatura.labels.emissao' | translate }}
          </div>
          <div class="info-value">
            {{ (notaEstadoNfe.dataEmissaoNotaEletronica | date: 'dd/MM/yyyy HH:mm') || '--/--/-- --:--' }}
          </div>
        </div>
        <div class="card-nfe-info-item col-span-2">
          <div class="info-label">
            <i class="pi pi-info-circle text-blue-500"></i>
            {{ 'fatura.labels.mensagem' | translate }}
          </div>
          <div class="info-value">{{ notaEstadoNfe.mensagemSief || '----------' }}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <button pButton
      type="button"
      class="p-button-secondary"
      [label]="'fatura.botoes.fechar' | translate"
      (click)="mostrarDialogEstadoNfe = false">
    </button>
    <button pButton
      type="button"
      icon="pi pi-send"
      *ngIf="notaEstadoNfe && ehNotaEletronica(notaEstadoNfe) && (estadoNfeValue(notaEstadoNfe) === 'EM_DEFINICAO' || estadoNfeValue(notaEstadoNfe) === 'COM_PROBLEMAS')"
      [label]="'fatura.botoes.transmitir' | translate"
      class="btn-primary"
      style="gap: 0.35rem"
      [loading]="emitindoNotaId === notaEstadoNfe.id"
      [disabled]="emitindoNotaId !== null"
      (click)="transmitir()">
    </button>
  </ng-template>
</p-dialog>
